import { storeSet, storeGet, storeRemove, storeClear } from './localStorage';

const TokenKey = 'Admin-Token';

export const getToken = () => storeGet(TokenKey);

export const setToken = (token: unknown) => storeSet(TokenKey, token);

export const setUser = (user: any) => storeSet('user', user);

export const removeToken = () => storeRemove(TokenKey);

export const clearToken = () => storeClear();
